import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import "./styles.css";
const container = document.getElementById("root");
if (!container) {
    throw new Error("The application root element could not be found.");
}
createRoot(container).render(_jsx(StrictMode, { children: _jsx(App, {}) }));
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker.register(`${process.env.PUBLIC_URL_BASE ?? ""}sw.js`).catch((error) => {
            console.error("Service worker registration failed:", error);
        });
    });
}
